var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatInputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333659 8.4987V9.66536H4.12533C5.13094 9.66536 6.09536 9.26589 6.80644 8.55481C7.51751 7.84373 7.91699 6.87931 7.91699 5.8737V2.5662L9.71949 4.3687L10.542 3.54036L7.33366 0.332031L4.12533 3.54036L4.94783 4.36286L6.75033 2.5662V5.8737C6.75033 7.33203 5.58366 8.4987 4.12533 8.4987H0.333659Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatInputIcon);
export default __webpack_public_path__ + "static/media/chat_input_icon.4dba5bc4886a82cbf98d8b3ee9cf2776.svg";
export { ForwardRef as ReactComponent };